import React from "react";

function Nodata() {
    return (
        <svg
            xmlns='http://www.w3.org/2000/svg'
            width='60'
            height='61'
            viewBox='0 0 60 61'
            fill='none'
        >
            <path
                d='M45.4998 34.7012V10.5002C45.4998 8.3006 44.199 6.5 42 6.5H10.0002C7.8006 6.5 6 8.3006 6 10.5002V42.5C6 44.699 7.8006 46.5002 10.0002 46.5002H34.2012C35.1288 51.0626 39.1638 54.5 43.9998 54.5C49.5216 54.5 54 50.0216 54 44.4998C54 39.6626 50.0622 35.6288 45.4998 34.7012ZM34.2012 43.7H9V9.5H42.4998V34.7012C40.5792 35.095 38.3165 36.0439 36.9302 37.4302C35.5439 38.8165 34.595 41.7794 34.2012 43.7ZM51.3 45.9998H45.4998V51.5H42.4998V45.9998H36.9302V42.9998H42.4998V37.4302H45.4998V42.9998H51.3V45.9998Z'
                fill='black'
                fill-opacity='0.16'
            />
            <path
                d='M38 16.7V14.4998H14V38.4998H16.2002V32.9H22.0004V38.4998H25.0004V32.9H30.9002V38.4998H33.0002V32.9H38V30.5H33.0002V24.8H38V22.5002H33.0002V16.7H38ZM16.2002 16.7H22.5002V22.5002H16.2002V16.7ZM16.2002 30.5V24.8H22.5002V30.5H16.2002ZM30.9002 30.5H25.0004V24.8H30.9002V30.5ZM30.9002 22.5002H25.0004V16.7H30.9002V22.5002Z'
                fill='black'
                fill-opacity='0.16'
            />
        </svg>
    );
}

export { Nodata };
